/**
 * Fehlermeldung zu Attributen.
 * - Instanzen werden von den Validatorfunktionen (am Metadatenattribut) erzeugt
 * - Instanzen werden von den computed Fehlermeldungslisten (am Datenattribut) verwaltet
 */
export default class ValidationError {
  static SeverityError = "Fehler";
  static SeverityWarning = "Warnung";

  constructor(servity, message,source) {
    this.servity = servity;
    this.message = message;
    this.source = source;
  }
  // Erzeuge einen Error
  static Error(message,source) {
    return new ValidationError(ValidationError.SeverityError,message,source);
  }
  // Erzeuge eine Warnung
  static Warning(message,source) {
    return new ValidationError(ValidationError.SeverityWarning,message,source);
  }

}